interface Assignment {
  assignment_classrooms: Classroom[];
}

interface Classroom {
  id: number;
  classroom_id: number;
}

const getRelevantWritePromptClassrooms = (
  classrooms: Classroom[],
  assignment: Assignment | undefined,
  allAssignments?: Assignment[],
): Classroom[] => {
  // If a specific assignment is provided, filter based on its classrooms
  if (assignment?.assignment_classrooms?.length) {
    const assignmentClassroomIds = assignment.assignment_classrooms.map(
      (classroom) => classroom?.classroom_id,
    );
    return classrooms?.filter((classroom) => {
      return assignmentClassroomIds?.includes(classroom?.id);
    });
  }

  // If no specific assignment but there are other assignments for this content,
  // filter based on ALL those assignments' classrooms.
  // This handles the case where selectedAssignmentId is missing from the URL,
  // but we still want to limit classroom options to those in relevant assignments.
  if (!assignment && allAssignments?.length) {
    const allAssignmentClassroomIds = new Set<number>();
    allAssignments.forEach((a) => {
      a?.assignment_classrooms?.forEach((classroom) => {
        if (classroom?.classroom_id) {
          allAssignmentClassroomIds.add(classroom.classroom_id);
        }
      });
    });

    if (allAssignmentClassroomIds.size > 0) {
      return classrooms?.filter((classroom) =>
        allAssignmentClassroomIds.has(classroom?.id),
      );
    }
  }

  return classrooms;
};

export default getRelevantWritePromptClassrooms;
